import React from 'react';
import './CartCaption.less';

export const CartCaption = ({text}) => {
	return <label className="cart-caption">{text}</label>;
};
